import createInlineButtons from './inline-buttons.js';
import createInsertButtons from './insert-buttons.js';
import 'wix-rich-content-plugin-commons';
import '../utils-c4245f57.js';
import 'lodash';
import '../defaults.js';
import 'wix-rich-content-editor-common';
import '../icons/ConvertToLinkIcon.js';
import 'react';
import './embedURLInputModal.js';
import 'prop-types';
import './SocialEmbedInsertModal.js';
import 'wix-rich-content-ui-components';
import '../types.js';
import 'wix-rich-content-common';
import '../consts.js';
import 'ricos-schema';
import '../icons/InstagramIcon.js';
import '../icons/TwitterIcon.js';
import '../icons/FacebookIcon.js';
import '../icons/TikTokIcon.js';
import '../icons/PinterestIcon.js';
import '../icons/YoutubeIcon.js';

const createToolbar = ({
  settings,
  setEditorState,
  getEditorState,
  isMobile,
  t,
  experiments
}) => {
  return {
    InlineButtons: createInlineButtons({ setEditorState, getEditorState }),
    InsertButtons: createInsertButtons({ settings, isMobile, t, experiments }),
    name: "link-preview"
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
